<template>
    <div>
        <div v-if="show" class="modal fade show d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">CO2 Emission Details</h5>
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="emission">
                        <div class="row">
                            <div class="col-md-6">
                                <h6 class="text-primary">Vehicle Information</h6>
                                <table class="table table-sm table-borderless">
                                    <tr>
                                        <td><strong>Chassis Number:</strong></td>
                                        <td>{{ emission.chassis_number || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Make:</strong></td>
                                        <td>{{ emission.make || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Model:</strong></td>
                                        <td>{{ emission.model || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Year:</strong></td>
                                        <td>{{ emission.year || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Industry Code:</strong></td>
                                        <td>{{ emission.industry_code || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Variant:</strong></td>
                                        <td>{{ emission.variant || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Class:</strong></td>
                                        <td>{{ emission.class || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Tare:</strong></td>
                                        <td>{{ emission.tare || '-' }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-6">
                                <h6 class="text-primary">Engine & Emissions</h6>
                                <table class="table table-sm table-borderless">
                                    <tr>
                                        <td><strong>Engine Type:</strong></td>
                                        <td>{{ emission.engine_type || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>CC Rating:</strong></td>
                                        <td>{{ emission.cc_rating || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Transmission:</strong></td>
                                        <td>{{ emission.transmission || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Test Cycle:</strong></td>
                                        <td>{{ emission.test_cycle || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Current Emission Standard:</strong></td>
                                        <td>{{ emission.current_emission_standard || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>CO₂ 3PWLTP:</strong></td>
                                        <td>{{ emission.co2_3pwltp || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>CCS Weight:</strong></td>
                                        <td>{{ emission.ccs_weight || '-' }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <h6 class="text-primary">CO₂ Differences</h6>
                                <table class="table table-sm table-borderless">
                                    <tr>
                                        <td><strong>CO₂ Difference (2024):</strong></td>
                                        <td>{{ emission.co2_difference_2024 || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>CO₂ Difference (2025):</strong></td>
                                        <td>{{ emission.co2_difference_2025 || '-' }}</td>
                                    </tr>
                                    <tr v-if="emission.co2_difference_notes">
                                        <td><strong>CO₂ Difference Notes:</strong></td>
                                        <td>{{ emission.co2_difference_notes }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <h6 class="text-primary">Fleet Average Charges</h6>
                                <table class="table table-sm table-borderless">
                                    <tr>
                                        <td><strong>Charge (2024):</strong></td>
                                        <td>{{ emission.fleet_average_charge_2024 || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Charge (2025):</strong></td>
                                        <td>{{ emission.fleet_average_charge_2025 || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Rate:</strong></td>
                                        <td>{{ emission.fleet_average_rate || '-' }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-6">
                                <h6 class="text-primary">Pay As You Go Charges</h6>
                                <table class="table table-sm table-borderless">
                                    <tr>
                                        <td><strong>Charge (2024):</strong></td>
                                        <td>{{ emission.pay_as_you_go_charge_2024 || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Charge (2025):</strong></td>
                                        <td>{{ emission.pay_as_you_go_charge_2025 || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Rate:</strong></td>
                                        <td>{{ emission.pay_as_you_go_rate || '-' }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="show" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
export default {
    name: 'EmissionModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        emission: {
            type: Object,
            default: null
        }
    },
    emits: ['close'],
    watch: {
        show(newValue) {
            if (newValue) {
                // Prevent body scrolling when modal is open
                document.body.style.overflow = 'hidden'
            } else {
                // Re-enable body scrolling
                document.body.style.overflow = 'auto'
            }
        }
    },
    beforeUnmount() {
        // Ensure body scrolling is re-enabled when component is destroyed
        document.body.style.overflow = 'auto'
    },
    methods: {
        closeModal() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
    margin: 2rem auto;
}

.modal-content {
    border-radius: 8px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.modal-header {
    border-bottom: 1px solid #dee2e6;
    background-color: #f8f9fa;
}

.modal-footer {
    border-top: 1px solid #dee2e6;
    background-color: #f8f9fa;
}

.table-borderless td {
    padding: 0.25rem 0.5rem;
    vertical-align: top;
}

.table-borderless td:first-child {
    width: 40%;
    font-weight: 500;
}

.text-primary {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
}
</style> 


// WEBPACK FOOTER //
// resources/js/components/Co2Emissions/EmissionModal.vue